<template>
    <div class="monitors">
        <div class="body " :class="{ 'quick-view-open': quickViewVisible }" :style="quickViewOffsetStyle" style="background:#f5f5f5;">
            <div class="page-content order-page-container" id="modalBodyPrint" >
                <div style="background:#f5f5f5;padding:10px">
                    <a-card class="page-card" :bordered="false" id="title-card">
                        <template slot="title">
                            <a-breadcrumb separator=">">
                                <a-breadcrumb-item>
                                    <router-link to="/cliente/monitores/cotacoes">
                                        Home
                                    </router-link>
                                </a-breadcrumb-item>

                                <a-breadcrumb-item>
                                    <router-link to="/cliente/monitores/ressuprimento">
                                        Monitor de Ressuprimento
                                    </router-link>
                                </a-breadcrumb-item>

                                <a-breadcrumb-item class="order-page-title">
                                    Produtos do Ressuprimento #{{ quotationNumber }}
                                </a-breadcrumb-item>
                            </a-breadcrumb>
                        </template>

                        <template slot="extra">
                            <div class="title-actions">

                                <a-button @click="goBack">
                                    <i class="fa-solid fa-arrow-left"></i>
                                    Voltar
                                </a-button>

                                <a-button @click="downloadExcel">
                                    <i class="fa-solid fa-file-excel"></i>
                                    Exportar Excel
                                </a-button>

                                <a-button @click="exportProducts">
                                    <i class="fa-solid fa-file-lines"></i>
                                    Exportar TXT
                                </a-button>

                                <a-button @click="download_pdf">
                                    <i class="fa-solid fa-print"></i>
                                    Imprimir
                                </a-button>
                                <a id="download-pdf" style="display: none"></a>

                                <a-button :loading="refreshingErp" :disabled="refreshingErp" @click="refreshErpData()">
                                    <i class="fa-solid fa-rotate"></i>
                                    Atualizar estoque/custo
                                </a-button>
                                <a-button 
                                @click="openNewProductModal" 
                                class="btn-add" 
                                type="primary" 
                                icon="plus"
                                >
                                    Adicionar Produtos
                                </a-button>

                            </div>
                        </template>
                        <a-row :gutter="[12,12]">
                            <a-col :xs="24" :lg="6">
                                <div class="request-title-container">
                                    <template v-if="!editingTitle">
                                        <div
                                            class="request-title-display"
                                            @click="startEditTitle"
                                        >
                                            <span>
                                                {{ item.nomeSolicitacao || 'Nova Requisição' }}
                                            </span>

                                            <a-icon
                                                type="edit"
                                                class="request-title-icon"
                                            />
                                        </div>
                                    </template>

                                    <template v-else>
                                        <a-input
                                            ref="requestNameInput"
                                            v-model="item.nomeSolicitacao"
                                            size="large"
                                            @pressEnter="saveTitle"
                                            @blur="() => editingTitle = false"
                                            class="request-title-input"
                                        />
                                        <a-icon 
                                            icon="save"
                                            @click="saveTitle"
                                        />
                                    </template>
                                </div>
                            </a-col>

                            <a-col :xs="24" :lg="6">
                                <div class="request-title-container">
                                    <template v-if="!editingStore">

                                        <div
                                            class="request-title-display"
                                            @click="editingStore = true"
                                        >
                                            <span>
                                                {{ nome_loja || 'Selecione uma empresa' }}
                                            </span>

                                            <a-icon
                                                type="edit"
                                                class="request-title-icon"
                                            />
                                        </div>

                                    </template>

                                    <template v-else>

                                        <a-select
                                            ref="storeSelect"
                                            v-model="selectedStore"
                                            show-search
                                            style="width: 100%"
                                            @change="saveStore"
                                            @blur="editingStore = false"
                                        >
                                            <a-select-option
                                                v-for="store in storesList"
                                                :key="store.id"
                                                :value="store.id"
                                            >
                                                {{ store.nome }}
                                            </a-select-option>
                                        </a-select>

                                    </template>
                                </div>
                            </a-col>
                        </a-row>
                    </a-card>
                </div>
                <div style="background:#f5f5f5;padding:0 10px 10px">
                    <a-card :bordered="false">
                        <a-row :gutter="[12, 12]">                                
                            <a-form layout="vertical" style="width: 100%">

                                <a-col :xs="24" :sm="12" :md="6">
                                    <a-input
                                        v-model="productFilter"
                                        placeholder="Nome do produto"
                                        allow-clear
                                    >
                                        <a-icon slot="prefix" type="search" />
                                    </a-input>
                                </a-col>

                                <a-col :xs="24" :sm="12" :md="6">
                                    <a-select
                                        v-model="categoryFilter"
                                        placeholder="Categorias"
                                        allow-clear
                                        style="width:100%"
                                        mode="multiple"
                                    >
                                        <a-select-option
                                            v-for="item in my_categories"
                                            :key="item.value"
                                            :value="item.value"
                                        >
                                            {{ item.text }}
                                        </a-select-option>
                                    </a-select>
                                </a-col>

                                <a-col :xs="24" :sm="12" :md="6">
                                    <a-select
                                        v-model="selectedItemFilters"
                                        placeholder="Itens"
                                        style="width:100%"
                                        @change="onItemFiltersChange"
                                    >
                                        <a-select-option value="all">
                                            Todos
                                        </a-select-option>

                                        <a-select-option value="directOrder">
                                            Pedido Direto
                                        </a-select-option>

                                        <a-select-option value="zeroQuantity">
                                            Quantidade Zero
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col flex="auto" class="actions-col">
                                    <a-form-item class="item-button">
                                        <div class="actions-right">
                                            <a-button
                                            type="default"
                                            icon="search"
                                            @click="load_my_products"
                                            >
                                                Filtrar
                                            </a-button>
                                        </div>
                                    </a-form-item>

                                </a-col>

                                <a-alert
                                    v-if="showSuggestionAlert"
                                    style="margin-top:16px"
                                    type="warning"
                                    show-icon
                                    message="Sugestão automática disponível"
                                >
                                    <template slot="description">
                                        Seu ajuste nos campos de quantidade/estoque ativou uma sugestão automática
                                        com base no histórico do produto e estoque atual. Deseja aplicar?

                                        <div style="margin-top:12px">
                                            <a-space>
                                                <a-button @click="closeSuggestionAlert">
                                                    Ignorar
                                                </a-button>

                                                <a-button
                                                    type="primary"
                                                    @click="applySuggestion"
                                                >
                                                    Aplicar Sugestões
                                                </a-button>
                                            </a-space>
                                        </div>
                                    </template>
                                </a-alert>

                            </a-form>
                        </a-row>
                    </a-card>
                </div>
                <div style="background:#f5f5f5;padding:0 10px 10px">
                    <div v-if="loading" class="loading">Carregando produtos...</div>
                    <div v-else class="page-content">
                        <a-card
                            :bordered="false"
                            class="table-card"
                        >
                            
                            <div class="resupply-table-container desktop">
                                <a-table
                                    :columns="columns"
                                    :dataSource="visible_products()"
                                    :pagination="false"
                                    :rowKey="record => record.id || record.pro_id"
                                    :row-selection="rowSelection"
                                    :scroll="{ y: tableHeight }"
                                    size="small"
                                    class="resupply-table"
                                >


                                    <!-- Embalagem -->
                                    <template slot="wrap" slot-scope="text, record">
                                        <div style="display:flex;align-items:center">
                                            {{
                                                record.pro_generico == 1
                                                    ? record.pro_unidade_compra
                                                    : record.pro_embalagem
                                            }}
                                        </div>
                                    </template>

                                    <!-- Quantidade -->
                                    <template slot="qtd" slot-scope="text, record, index">
                                        <div class="input-wrapper">
                                            <input
                                                type="number"
                                                :value="record.qtd"
                                                min="0"
                                                class="input-qtd not-print"
                                                :class="{
                                                    'new-product-quantity': record.isNewProduct,
                                                }"
                                                @focus="saveOriginalValues(record)"
                                                @input="handleInputChange(record, 'qtd', $event.target.value)"
                                                @blur="saveFieldAutomatically(record, 'qtd')"
                                                @keydown="handleKeydown($event, 'qtd', record, index)"
                                                data-field="qtd"
                                                :data-row="index"
                                            />

                                            <i
                                                v-if="record.qtdSaved"
                                                class="fa fa-check"
                                            ></i>
                                        </div>

                                        <span class="show-print">
                                            {{ formatNumber(record.qtd) }}
                                        </span>
                                    </template>

                                    <!-- Estoque -->
                                    <template slot="estoque" slot-scope="text, record, index">
                                        <div class="input-wrapper">
                                            <input
                                                v-model="record.estoque"
                                                type="number"
                                                min="0"
                                                class="input-num not-print"
                                                :class="{
                                                    'estoque-field': record.estoqueSaved,
                                                }"
                                                @focus="saveOriginalValues(record)"
                                                @input="handleInputChange(record, 'estoque', $event.target.value)"
                                                @blur="handleBlur(record, 'estoque')"
                                                @keydown="handleKeydown($event, 'estoque', record, index)"
                                                data-field="estoque"
                                                :data-row="index"
                                            />

                                            <i
                                                v-if="record.estoqueSaved"
                                                class="fa fa-check"
                                            ></i>
                                        </div>

                                        <span class="show-print">
                                            {{ formatNumber(record.estoque) }}
                                        </span>
                                    </template>

                                    <template slot="lastPrice" slot-scope="text, record">
                                        {{ record.last_price != null ? $options.filters.currency(record.last_price) : "—" }}
                                    </template>

                                    <!-- Quantidade padrão -->
                                    <template slot="qtdPadrao" slot-scope="text, record, index">
                                        <div class="input-wrapper">
                                            <input
                                                v-model="record.qtd_padrao"
                                                type="number"
                                                min="0"
                                                class="input-num not-print"
                                                :class="{
                                                    'qtd-padrao-field': record.qtdPadraoSaved,
                                                }"
                                                @focus="saveOriginalValues(record)"
                                                @input="handleInputChange(record, 'qtdPadrao', $event.target.value)"
                                                @blur="handleBlur(record, 'qtdPadrao')"
                                                @keydown="handleKeydown($event, 'qtdPadrao', record, index)"
                                                data-field="qtdPadrao"
                                                :data-row="index"
                                            />

                                            <i
                                                v-if="record.qtdPadraoSaved"
                                                class="fa fa-check"
                                            ></i>
                                        </div>

                                        <span class="show-print">
                                            {{ formatNumber(record.qtd_padrao) }}
                                        </span>
                                    </template>

                                    <!-- Sugestão -->
                                    <template slot="suggestion" slot-scope="text, record">
                                        {{ getSugestionPrice(record) }}
                                    </template>

                                    <!-- Ações -->
                                    <template slot="actions" slot-scope="text, record">
                                        <ActionMenu class="not-print" :actions="getActions(record)" />
                                    </template>

                                </a-table>
                                <transition name="slide-up">
                                    <div
                                        v-if="selectedProductsCount > 0"
                                        class="resupply-footer"
                                    >
                                        <div class="resupply-footer-left">
                                            <div class="resupply-footer-info">
                                                <span class="resupply-footer-count">
                                                    {{ selectedProductsCount }}
                                                </span>

                                                produtos selecionados
                                            </div>
                                        </div>

                                        <div class="resupply-footer-right">

                                            <a-button
                                                size="large"
                                                @click="clearSelection"
                                            >
                                                <span class="material-icons-round">
                                                    clear
                                                </span>

                                                Limpar Seleção
                                            </a-button>

                                            <a-button
                                                type="danger"
                                                size="large"
                                                @click="removeSelectedOneByOne"
                                            >
                                                <i class="fa-solid fa-trash"></i>
                                                Remover Selecionados
                                            </a-button>

                                            <a-button
                                                size="large"
                                                :loading="refreshingErp"
                                                :disabled="refreshingErp"
                                                @click="refreshErpData(selectedProducts)"
                                            >
                                                <i class="fa-solid fa-rotate"></i>
                                                Atualizar estoque/custo
                                            </a-button>

                                            <a-tooltip :title="store_number ? '' : 'Ressuprimento sem loja: não é possível calcular a sugestão.'">
                                                <span>
                                                    <a-button
                                                        size="large"
                                                        :loading="calculatingSuggestion"
                                                        :disabled="calculatingSuggestion || !store_number"
                                                        @click="openSuggestionAlgorithm"
                                                    >
                                                        <i class="fa-solid fa-wand-magic-sparkles"></i>
                                                        Calcular sugestão
                                                    </a-button>
                                                </span>
                                            </a-tooltip>

                                            <a-button
                                                type="primary"
                                                size="large"
                                                @click="extract"
                                            >
                                                <i class="fa-solid fa-box-open"></i>
                                                Gerar Nova Requisição
                                            </a-button>

                                        </div>
                                    </div>
                                </transition>
                            </div>
                            <div class="resupply-cards-container mobile">
                                <div class="resupply-card" v-for="(item, i) in visible_products()" :key="i">
                                    <div class="card-header" style="background: none">
                                        <input type="checkbox" v-model="item.extract" @change="toggleProductSelection" />
                                        <div class="card-title">
                                            {{ item.pro_descricao }}
                                            <span>{{ item.pro_ean }}</span>
                                        </div>
                                    </div>

                                    <div class="card-body">
                                        <div class="row">
                                            <label>Embalagem:</label>
                                            <div>{{ item.pro_embalagem }}</div>
                                        </div>
                                        <div class="row">
                                            <label>Qtd.:</label>
                                            <input type="number" :value="item.qtd" min="0" class="input-qtd" :class="{
                                                'saved-feedback': item.showSaveFeedback,
                                                'new-product-quantity': item.isNewProduct,
                                            }" @input="handleInputChange(item, 'qtd', $event.target.value)"
                                                @blur="saveFieldAutomatically(item, 'qtd')" />
                                        </div>
                                        <div class="row">
                                            <label>Estoque:</label>
                                            <input type="number" v-model="item.estoque" min="0" class="input-num" :class="{
                                                'estoque-field': item.estoqueSaved,
                                            }" @input="handleInputChange(item, 'estoque', $event.target.value)"
                                                @blur="handleBlur(item, 'estoque')" />
                                        </div>
                                        <div class="row">
                                            <label>Últ. Custo:</label>
                                            <div>{{ item.last_price != null ? $options.filters.currency(item.last_price) : "—" }}</div>
                                        </div>
                                        <div class="row">
                                            <label>Qtd. Padrão:</label>
                                            <input type="number" v-model="item.qtd_padrao" min="0" class="input-num" :class="{
                                                'qtd-padrao-field': item.qtdPadraoSaved,
                                            }" @input="handleInputChange(item, 'qtdPadrao', $event.target.value)"
                                                @blur="handleBlur(item, 'qtdPadrao')" />
                                        </div>
                                        <div class="row">
                                            <label>Sugestão:</label>
                                            <div>{{ getSugestionPrice(item) }}</div>
                                        </div>

                                        <div class="card-actions">
                                            <button title="Editar" @click="editProduct(item)">
                                                <span class="material-symbols-outlined">edit</span>
                                            </button>
                                            <button title="Excluir" @click="remove(item)">
                                                <span class="material-symbols-outlined">delete</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a-card>
                    </div>
                </div>
                
            </div>
            <product-quick-view-vertical
                :visible="quickViewVisible"
                :width="quickViewWidth"
                :product="quickViewProduct"
                :last-purchase="lastPurchase"
                :stock="stock"
                :last-sale="lastSale"
                :sales-analysis="salesAnalysis"
                :chart-labels="chartLabels"
                :sales-points="salesPoints"
                :purchase-points="purchasePoints"
                :sales-highlights="salesHighlights"
                :purchase-highlights="purchaseHighlights"
                :purchases="purchases"
                :network-sales="networkSales"
                :network-total="networkTotal"
                :stores="quickViewStores"
                :selected-store-id="selectedStoreId"
                :has-navigation="hasQuickViewNavigation"
                :can-go-previous="canGoPreviousQuickViewProduct"
                :can-go-next="canGoNextQuickViewProduct"
                :current-index="quickViewSiblingIndex"
                :total-count="quickViewSiblings ? quickViewSiblings.length : 0"
                :read-only="true"
                :data-unavailable="quickViewDataUnavailable"
                :loading="quickViewLoading"
                :diagnostics-stores="diagnosticsStores"
                :updated-at="updatedAt"
                @close="closeProductQuickView"
                @expand="openQuickViewWindow"
                @edit-packaging="editQuickViewPackaging"
                @previous-product="goToPreviousQuickViewProduct"
                @next-product="goToNextQuickViewProduct"
            />
            <product-quick-view-window
                :visible="quickViewWindowVisible"
                :product="quickViewProduct"
                :last-purchase="lastPurchase"
                :stock="stock"
                :last-sale="lastSale"
                :sales-analysis="salesAnalysis"
                :sales-points="salesPoints"
                :purchase-points="purchasePoints"
                :purchases="purchases"
                :network-sales="networkSales"
                :network-total="networkTotal"
                :stores="quickViewStores"
                :selected-store-id="selectedStoreId"
                :has-navigation="hasQuickViewNavigation"
                :can-go-previous="canGoPreviousQuickViewProduct"
                :can-go-next="canGoNextQuickViewProduct"
                :current-index="quickViewSiblingIndex"
                :total-count="quickViewSiblings ? quickViewSiblings.length : 0"
                :read-only="true"
                :data-unavailable="quickViewDataUnavailable"
                :loading="quickViewLoading"
                :diagnostics-stores="diagnosticsStores"
                :updated-at="updatedAt"
                @close="closeQuickViewWindow"
                @collapse="collapseQuickViewWindow"
                @edit-packaging="editQuickViewPackaging"
                @previous-product="goToPreviousQuickViewProduct"
                @next-product="goToNextQuickViewProduct"
            />

            <suggestion-algorithm-modal
                :value="suggestionAlgorithm"
                :visible="algorithmModalVisible"
                :hidden-fields="['exibicao']"
                :hidden-unidade-options="['ultima_compra']"
                @reset="resetSuggestionAlgorithm"
                @close="algorithmModalVisible = false"
                @save="calculateMiraiSuggestion"
            />
            <resupply-products-new-modal-v2 v-if="showResuplyNewProductModal" :closeDialog="closeResuplyNewProductModal"
                :quotation="quotationId" :store-number="store_number" :client-id="clientId"
                :suggestion-algorithm="suggestionAlgorithm" />
            <product-wrap-modal-v2 v-if="open_edit_wrap && current_product" :product="current_product" @close="
                open_edit_wrap = false;
            getProducts();
            " />
        </div>
    </div>
</template>
<script>
import StandardInput from "@/components/ui/inputs/StandardInput.vue";
import QuotationService from "@/services/QuotationService";
import RequestsService from "@/services/v2/requests.service";
import RequestsServiceV3 from "@/services/v3/request.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import ProductService from "@/services/v2/products.service";
import ResupplyProductsNewModalV2 from "@/modals/resupply-products/resupply-products-new-v2.modal.vue";
import { perm_mixin } from "@/mixins/permission.mixin";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import ProductWrapModalV2 from "@/modals/product-wrap/product-wrap-v2.modal";
import ActionMenu from "@/components/popovers/action-menu.popover.vue";
import ProductQuickViewVertical from "@/pages/monitors/winners-v2/components/modals/ProductQuickViewVertical.vue";
import ProductQuickViewWindow from "@/pages/monitors/winners-v2/components/modals/ProductQuickViewWindow.vue";
import { productQuickViewMixin } from "@/mixins/product-quick-view.mixin";
import ExcelDownload from "@/services/ExcelDownload.js";
import RequestProductService from "@/services/v3/requests/request-products.service";
import MiraiService, { buildSuggestionAlgoritmo, suggestionCodeKey, suggestionQuantity } from "@/services/MiraiService";
import SuggestionAlgorithmModal from "@/modals/diagnosis/SuggestionAlgorithmModal.vue";

const SUGGESTION_ALGORITHM_STORAGE_KEY = "resupply_suggestion_algorithm";

const defaultSuggestionAlgorithm = {
    estoque: "real",
    pendencia: "desconsiderar",
    cobertura: "tempo_compra",
    cobertura_dias: 30,
    giro: "ponderado",
    unidade: "unidade",
    exibicao: "todos",
};

export default {
    mixins: [perm_mixin, loaderMixin, productQuickViewMixin],
    components: {
        StandardInput,
        "resupply-products-new-modal-v2": ResupplyProductsNewModalV2,
        "product-wrap-modal-v2": ProductWrapModalV2,
        SuggestionAlgorithmModal,
        ActionMenu,
        ProductQuickViewVertical,
        ProductQuickViewWindow,
    },
    props: ["quotation"],
    data() {
        return {
            tableHeight: 500,
            editingStore: false,
            editingTitle: false,
            hasFocus: false,
            expandedRowKeys: [],
            resupplyProductItems: {},
            selectedMap: {},
            selectedRowKeys: [],
            products_service: new RequestProductService(),
            quotationData: null,
            quotationNumber: "",
            selectAll: false,
            isSelectAllIndeterminate: false,
            showActions: false,
            products: [],
            selectUnit: "",
            svc: new RequestsService(),
            svc_v3: new RequestsServiceV3(),
            service: new QuotationService(),
            services: new ProductService(),
            loading: false,
            savedProducts: [],
            editing: false,
            item: {
                nomeSolicitacao: "",
            },
            my_products: [],
            my_categories: [],
            productFilter: "",
            categoryFilter: [],
            product_name_filter: null,
            current_product: null,
            selectedProduct: {},
            subrequestData: null,
            subrequests: [],
            all_subrequests: [],
            current_subrequest: null,
            store_number: null,
            quotation_info: null,
            has_attempted_store_load: false,
            current_store_number: null,
            showNewProductModal: false,
            is_loading_provider: false,
            isLocked: true,
            currentProductIndex: 0,
            showModal: false,
            showResuplyNewProductModal: false,
            newProductData: {},
            showSuggestionAlert: false,
            pendingSuggestionProduct: null,
            originalProductValues: {},
            suggestionTimeout: null,
            filters: {
                directOrder: false,
                zeroQuantity: false,
            },
            selectedItemFilters: [],
            cancelSource: null,
            searchTime: null,
            originalProducts: [],
            filteredProducts: [],
            whitelabel: null,
            open_edit_wrap: false,
            autoSaveTimeout: null,
            pendingAutoSaves: new Map(),
            showSaveButtons: {},
            lastFocusedField: null,
            lastFocusedProductId: null,
            newlyAddedProductIds: new Set(),
            savingStatus: "idle",
            saveTimeout: null,
            lastSaveTime: null,
            nome_loja: null,
            store_id: null,
            refreshingErp: false,
            algorithmModalVisible: false,
            suggestionAlgorithm: { ...defaultSuggestionAlgorithm },
            suggestionProducts: [],
            calculatingSuggestion: false,
            columns: [
                {
                    title: 'EAN',
                    key: 'pro_ean',
                    dataIndex: 'pro_ean',
                    width: 120,
                },
                {
                    title: 'Código Interno',
                    key: 'pro_codInterno',
                    dataIndex: 'pro_codInterno',
                    width: 120,
                },
                {
                    title: 'Nome',
                    key: 'pro_descricao',
                    dataIndex: 'pro_descricao',
                    width: 300,
                },
                {
                    title: 'Embalagem',
                    key: 'pro_embalagem',
                    dataIndex: 'pro_embalagem',
                    width: 120,
                    scopedSlots: {
                        customRender: 'wrap'
                    }
                },
                {
                    title: 'Qtd.',
                    key: 'qtd',
                    dataIndex: 'qtd',
                    width: 80,
                    scopedSlots: {
                        customRender: 'qtd'
                    }
                },
                {
                    title: 'Estoque',
                    key: 'estoque',
                    dataIndex: 'estoque',
                    width: 80,
                    scopedSlots: {
                        customRender: 'estoque'
                    }
                },
                {
                    title: 'Últ. Custo',
                    key: 'last_price',
                    dataIndex: 'last_price',
                    width: 90,
                    scopedSlots: {
                        customRender: 'lastPrice'
                    }
                },
                {
                    title: 'Qtd.Padrão',
                    key: 'qtd_padrao',
                    dataIndex: 'qtd_padrao',
                    width: 80,
                    scopedSlots: {
                        customRender: 'qtdPadrao'
                    }
                },
                {
                    title: 'Sugestão',
                    key: 'suggestion',
                    width: 80,
                    customRender: (text, record) => this.getSugestionPrice(record)
                },
                {
                    title: 'Ações',
                    key: 'actions',
                    width: 60,
                    align: 'center',
                    scopedSlots: {
                        customRender: 'actions'
                    }
                }
            ]
        };
    },
    computed: {
        rowSelection() {
            return {
                selectedRowKeys: this.selectedRowKeys,

                onChange: (selectedRowKeys) => {
                    this.selectedRowKeys = selectedRowKeys;
                },
            };
        },

        selectedProducts() {
            const selectedKeys = new Set(this.selectedRowKeys);

            return this.visible_products().filter(product =>
                selectedKeys.has(
                    product.id || product.pro_id
                )
            );
        },

        selectedProductsCount() {
            return this.selectedProducts.length;
        },
        quotationId() {
            return Number(this.$route.params.id || this.quotation);
        },
        clientId() {
            return this.$store.state.user.cli_id;
        },
        currentStoreNumber() {
            return this.store_number ? Number(this.store_number) : 0;
        },
        selectedProducts() {
            const visibleProducts = this.visible_products();

            if (!Array.isArray(visibleProducts)) {
                return [];
            }

            const selectedKeys = new Set(this.selectedRowKeys);

            return visibleProducts.filter(product =>
                selectedKeys.has(product.id || product.pro_id)
            );
        },
        selectedProductsCount() {
            return Array.isArray(this.selectedProducts) ? this.selectedProducts.length : 0;
        },
        hasActiveItemFilters() {
            return this.filters.directOrder || this.filters.zeroQuantity;
        },
        activeItemFiltersCount() {
            let count = 0;
            if (this.filters.directOrder) count++;
            if (this.filters.zeroQuantity) count++;
            return count;
        },
    },
    methods: {
        updateTableHeight() {
            const table = this.$el.querySelector('.resupply-table')
            const top = table.getBoundingClientRect().top

            this.tableHeight = window.innerHeight - top - 40
        },
        startEditStore() {
            this.editingStore = true;

            this.$nextTick(() => {
                this.$refs.storeSelect.focus();
            });
        },

        saveStore(value) {
            this.setSelectedStore(value);
            this.editingStore = false;
        },
        startEditTitle() {
            this.editingTitle = true;

            this.$nextTick(() => {
                this.$refs.requestNameInput.focus();
            });
        },

        saveTitle() {
            this.editingTitle = false;
            this.save_title();
        },
        clearSelection(){
            this.selectedRowKeys = []
            this.selectedMap = {}
            this.resupplyProductItems = {}
            this.expandedRowKeys = []
        },
        matchesFilter(description, filter) {
            if (!filter) return true;
            if (!description) return false;

            const lowerDesc = description.toLowerCase();
            const lowerFilter = filter.toLowerCase();

            if (lowerFilter.includes('%') || lowerFilter.includes('.')) {
                // Escape regex special chars except % and ., then replace both with .*
                const regexPattern = lowerFilter
                    .replace(/[+*?^${}()|[\]\\]/g, '\\$&')
                    .replace(/%|\./g, '.*');
                return new RegExp(regexPattern).test(lowerDesc);
            }

            return lowerDesc.includes(lowerFilter);
        },
        goBack() {
            this.$router.push("/cliente/monitores/ressuprimento");
        },
        async refreshErpData(products = null) {
            if (this.pendingAutoSaves.size > 0 || this.savingStatus === "saving") {
                this.snack("Aguarde o salvamento das alterações antes de atualizar.", "error");
                return;
            }

            const items = products
                ? products.map((product) => ({ product_id: product.pro_id, store_id: this.store_id || 0 }))
                : null;

            if (items && !items.length) return;

            this.refreshingErp = true;

            try {
                const response = await this.svc_v3.refresh_erp_data(this.quotationId, items);
                const updated = response.data && response.data.products ? response.data.products.length : 0;

                this.snack(
                    updated
                        ? `Estoque e custo atualizados para ${updated} produto(s).`
                        : "Nenhum produto foi encontrado no ERP."
                );

                await this.getProducts();
            } catch (error) {
                this.snack("Não foi possível atualizar estoque e custo.", "error");
                ErrorHandlerService.handle(error, this.$store);
            } finally {
                this.refreshingErp = false;
            }
        },
        loadSuggestionAlgorithm() {
            try {
                const saved = JSON.parse(localStorage.getItem(SUGGESTION_ALGORITHM_STORAGE_KEY));
                if (saved && typeof saved === "object") {
                    return { ...defaultSuggestionAlgorithm, ...saved };
                }
            } catch (error) {
                return { ...defaultSuggestionAlgorithm };
            }
            return { ...defaultSuggestionAlgorithm };
        },
        saveSuggestionAlgorithm(algoritmo) {
            try {
                localStorage.setItem(SUGGESTION_ALGORITHM_STORAGE_KEY, JSON.stringify(algoritmo));
                return true;
            } catch (error) {
                return false;
            }
        },
        openSuggestionAlgorithm() {
            if (this.pendingAutoSaves.size > 0 || this.savingStatus === "saving") {
                this.snack("Aguarde o salvamento das alterações antes de calcular a sugestão.", "error");
                return;
            }

            this.suggestionProducts = [...this.selectedProducts];
            this.suggestionAlgorithm = this.loadSuggestionAlgorithm();
            this.algorithmModalVisible = true;
        },
        resetSuggestionAlgorithm() {
            this.suggestionAlgorithm = { ...defaultSuggestionAlgorithm };
        },
        async calculateMiraiSuggestion() {
            this.algorithmModalVisible = false;

            const algoritmo = buildSuggestionAlgoritmo(this.suggestionAlgorithm);

            this.saveSuggestionAlgorithm(algoritmo);

            const products = this.suggestionProducts;
            const withCode = products.filter((product) => suggestionCodeKey(product.pro_codInterno) !== "");

            if (!withCode.length) {
                this.snack("Nenhum dos produtos selecionados tem código interno.", "error");
                return;
            }

            this.calculatingSuggestion = true;

            try {
                const response = await new MiraiService(this.clientId).suggestion({
                    storeNumber: String(this.store_number),
                    internalCodes: withCode.map((product) => suggestionCodeKey(product.pro_codInterno)),
                    algoritmo,
                });

                const byCode = new Map(
                    (response.data.data || []).map((row) => [suggestionCodeKey(row.internal_code), row])
                );

                const changes = [];
                withCode.forEach((product) => {
                    const row = byCode.get(suggestionCodeKey(product.pro_codInterno));
                    if (!row) return;
                    changes.push({ product, quantidade: suggestionQuantity(product, row, algoritmo) });
                });

                const ignored = products.length - changes.length;

                if (!changes.length) {
                    this.snack("Nenhum dos produtos selecionados tem dados no ERP.", "error");
                    return;
                }

                const zeros = changes.filter((change) => change.quantidade === 0).length;

                this.confirm_action({
                    message: `Aplicar a sugestão em ${changes.length} produto(s)?`,
                    subtitle: `${zeros} ficarão com quantidade 0. ${ignored} sem código interno ou sem dados no ERP não serão alterados.`,
                    confirm_text: "Aplicar sugestão",
                    callback: () => this.applyMiraiSuggestion(changes),
                });
            } catch (error) {
                this.snack("Não foi possível calcular a sugestão.", "error");
                ErrorHandlerService.handle(error, this.$store);
            } finally {
                this.calculatingSuggestion = false;
            }
        },
        async applyMiraiSuggestion(changes) {
            try {
                await this.service.updateQuotationProductsAmount(
                    this.quotationId,
                    changes.map(({ product, quantidade }) => ({ pro_id: product.pro_id, quantidade }))
                );

                changes.forEach(({ product, quantidade }) => {
                    product.qtd = quantidade;
                    product.quantidade = quantidade;
                    product.originalQtd = quantidade;
                });

                this.snack(`Sugestão aplicada em ${changes.length} produto(s).`);
                await this.getProducts();
            } catch (error) {
                this.snack("Não foi possível salvar a sugestão.", "error");
                ErrorHandlerService.handle(error, this.$store);
            }
        },
        formatNumber(value) {
            if (value === null || value === undefined) return "0";
            const num = parseFloat(value);
            return isNaN(num) ? "0" : num.toString();
        },
        edit_wrap(product) {
            product.embalagem = product.pro_embalagem;
            product.descricaoProduto = product.pro_descricao;
            this.current_product = product;
            this.open_edit_wrap = true;
        },
        openNewProductModal() {
            this.newProductData = {};
            this.suggestionAlgorithm = this.loadSuggestionAlgorithm();
            this.showResuplyNewProductModal = true;
        },

        closeResuplyNewProductModal() {
            this.showResuplyNewProductModal = false;
            this.newProductData = {};

            this.getProducts();
        },
        handleProductSaved(savedProduct) {
            this.snack("Produto adicionado com sucesso!");
            if (savedProduct && savedProduct.pro_id) {
                const alreadyExists = this.products.some((p) => p.pro_id === savedProduct.pro_id);

                if (!alreadyExists) {
                    this.$set(savedProduct, "isNewProduct", true);
                }
            }
        },
        onItemFiltersChange(values) {
            if (!Array.isArray(values)) {
                values = [values];
            }

            this.selectedItemFilters = values;

            if (values.includes("all")) {
                this.filters.directOrder = false;
                this.filters.zeroQuantity = false;
                this.selectedItemFilters = ["all"];
            } else {
                this.filters.directOrder = values.includes("directOrder");
                this.filters.zeroQuantity = values.includes("zeroQuantity");
                this.selectedItemFilters = values.filter((value) => value !== "all");
            }
        },
        async loadQuotationData() {
            if (this.quotationId) {
                this.loading = true;
                try {
                    await this.getProducts();
                    await this.loadRequestName();
                } catch (error) {
                    this.handleError(error);
                } finally {
                    this.loading = false;
                }
            }
            this.quotationNumber = this.quotationId;
        },
        async loadRequestName() {
            this.loading = true;
            try {
                const response = await this.service.listResupply();
                const data = response.data;

                if (data && data.cotacoes && data.cotacoes.data) {
                    const requisicaoAtual = data.cotacoes.data.find(
                        (cotacao) => cotacao.numeroCotacao == this.quotationId
                    );

                    if (requisicaoAtual) {
                        this.item.nomeSolicitacao =
                            requisicaoAtual.nomeSolicitacao ||
                            `Requisição ${this.quotationId}`;
                        this.item.nomeLoja = requisicaoAtual.nomeLoja || "Não especificada";
                    } else {
                        this.item.nomeSolicitacao = `Requisição ${this.quotationId}`;
                    }
                }
            } catch (error) {
                console.error("Erro ao carregar nome da requisição:", error);
                this.item.nomeSolicitacao = `Requisição ${this.quotationId}`;
                ErrorHandlerService.handle(error, this.$store);
            } finally {
                this.loading = false;
            }
        },
        group_subrequests(data) {
            let result = [];
            if (!data || !Array.isArray(data)) {
                return result;
            }

            data.forEach((s) => {
                if (!s) return;

                var found = result.find((ss) => ss && ss.vendedor_id == s.vendedor_id);
                if (found) {
                    found.total = (found.total || 0) + (s.total || 0);
                    return;
                } else {
                    found = {
                        ...s,
                        total: s.total || 0,
                    };
                }
                result.push(found);
            });
            return result;
        },
        sort_subrequests() {
            let result = [];
            this.is_loading_provider = false;
            if (this.subrequests && Array.isArray(this.subrequests)) {
                result = result.concat(
                    this.subrequests.sort((a, b) => {
                        const nomeA = a?.for_nome || "";
                        const nomeB = b?.for_nome || "";
                        return nomeA.localeCompare(nomeB);
                    })
                );
                this.subrequests = result;
            }
        },
        async getProducts() {
            if (!this.quotationId) return;

            try {
                const response = await this.products_service.resupply_products(
                    this.quotationId
                );

                const data = response.data;

                const store = Array.isArray(data.loja)
                    ? data.loja[0]
                    : data.loja;

                if (store) {
                    this.store_number = store.loj_numeroLoja;
                    this.current_store_number = store.loj_numeroLoja;
                    this.nome_loja = store.loj_descricao
                    this.store_id = store.loj_id
                }
                const products = data.produtos?.data ?? data.produtos ?? [];

                const currentProductIds = this.products?.length
                    ? new Set(this.products.map(p => p.pro_id))
                    : new Set();

                this.originalProducts = products.map(product => ({
                    ...product,

                    extract: false,

                    qtd: product.quantidade || 0,
                    estoque: product.estoque || 0,
                    qtdPadrao: product.qtd_padrao || 0,
                    sugestoes: product.pro_sugestao || 0,

                    selectedEmbalagem: this.extractEmbalagem(product),

                    originalQtd: product.quantidade || 0,
                    originalEstoque: product.estoque || 0,
                    originalQtdPadrao: product.qtd_padrao || 0,

                    estoqueSaved: false,
                    qtdPadraoSaved: false,

                    isNewProduct:
                        this.products?.length > 0 &&
                        !currentProductIds.has(product.pro_id),
                }));

                this.products = [...this.originalProducts];

                this.selectAll = false;
                this.isSelectAllIndeterminate = false;
                this.showActions = false;

                this.updateSelectAllState();

                this.quotationNumber = this.quotationId;

            } catch (error) {
                ErrorHandlerService.handle(error, this.$store);
                throw error;
            }
        },
        save_title() {
            const requestId = this.quotationId || this.quotation;

            if (!requestId || !this.item || !this.item.nomeSolicitacao) {
                console.error("ID da requisição ou nome não encontrado");
                this.snack("Erro: ID da requisição não encontrado", "error");
                return;
            }

            this.loading = true;
            this.svc_v3
                .update_resupply_title(requestId, this.item.nomeSolicitacao)
                .then((resp) => {
                    this.editing = false;
                    this.loading = false;
                    this.snack("Atualizado com sucesso!");
                })
                .catch((error) => {
                    this.loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        editName() {
            this.editing = true;
            this.$nextTick(() => {
                const input = document.getElementById("editNameInput");
                if (input) {
                    input.focus();
                    input.select();
                }
            });
        },
        async downloadExcel() {
            try {
                const response = await this.products_service.resupply_products(
                    this.quotationId,
                    { export: 'excel' },
                    { responseType: 'blob' }
                );

                const url = window.URL.createObjectURL(new Blob([response.data]));

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `ressuprimento-${this.quotationId}.xls`
                );

                document.body.appendChild(link);
                link.click();
                link.remove();

                window.URL.revokeObjectURL(url);
            } catch (error) {
                ErrorHandlerService.handle(error, this.$store);
            }
        },
        download_pdf() {

            const callback = (data) => {

                const file = new Blob(
                    [data],
                    { type: "application/pdf" }
                );

                const fileURL = URL.createObjectURL(file);

                const el = document.getElementById("download-pdf");

                const title =
                    "produtos-cotacao-" +
                    this.quotationId +
                    ".pdf";

                el.download = title;
                el.href = fileURL;
                el.click();

                setTimeout(() => {
                    window.URL.revokeObjectURL(fileURL);
                }, 100);
            };

            this.is_loading_pdf = true;

            this.products_service
                .resupply_products(
                    this.quotationId,
                    {
                        export: "pdf",
                    },
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => response.data)
                .then(callback)
                .catch((error) => {

                    this.is_loading_pdf = false;

                    ErrorHandlerService.handle(
                        error,
                        this.$store
                    );
                })
                .finally(() => {
                    this.is_loading_pdf = false;
                });
        },
        print() {
            setTimeout(() => {
                const printContent = document.getElementById("modalBodyPrint").cloneNode(true);

                const notPrintElements = printContent.querySelectorAll(".not-print");
                notPrintElements.forEach((el) => el.remove());

                const printElements = printContent.querySelectorAll(".show-print");
                printElements.forEach((el) => {
                    el.style.display = "block";
                });

                const printStyles = `
          <style>
            @media print {
              body { margin: 20px; font-family: Arial, sans-serif; }
              .not-print, .not-print * { display: none !important; }
              .show-print, .show-print * { display: block !important; }
              .print-header { display: flex !important; margin-bottom: 20px; border-bottom: 2px solid #333; padding-bottom: 15px; }
              .resupply-table { width: 100%; border-collapse: collapse; font-size: 12px; }
              .resupply-table th, .resupply-table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              .resupply-table th { background-color: #f5f5f5; font-weight: bold; }
              .resupply-table-container { margin-top: 20px; }
              @page { margin: 15mm; }
              h2 { color: #333; margin-bottom: 10px; }
            }
          </style>
        `;

                const conteudoImpressao = `
          <html>
            <head>
              <title>Produtos da Requisição - ${this.quotationNumber}</title>
              ${printStyles}
            </head>
            <body>
              ${printContent.innerHTML}
            </body>
          </html>
        `;

                const telaImpressao = window.open("", "_blank", "width=800,height=600");
                telaImpressao.document.write(conteudoImpressao);
                telaImpressao.document.close();

                setTimeout(() => {
                    telaImpressao.focus();
                    telaImpressao.print();
                    telaImpressao.close();
                }, 500);
            }, 500);
        },
        exportProducts() {
            let text = "";
            this.visible_products().forEach(
                (t) => (text += `${t.pro_ean},${t.quantidade},${t.estoque || 0}\n`)
            );
            var blob = new Blob([text], {
                type: "text/plain;charset=utf-8",
            });
            saveAs(blob, "products.txt");
        },
        visible_products() {
            if (!this.originalProducts || !Array.isArray(this.originalProducts)) {
                return [];
            }

            let resp = this.originalProducts.filter((p) => !p.deleted);

            if (this.productFilter) {
                resp = resp.filter((p) =>
                    this.matchesFilter(p.pro_descricao, this.productFilter)
                );
            }

            if (this.categoryFilter && this.categoryFilter.cat_id) {
                resp = resp.filter((p) => p.cat_id == this.categoryFilter.cat_id);
            }

            const itemFilters = Array.isArray(this.selectedItemFilters)
                ? this.selectedItemFilters
                : [this.selectedItemFilters];

            if (!itemFilters.includes("all")) {
                if (this.filters.directOrder) {
                    resp = resp.filter(
                        (p) =>
                            p.pro_pedido_direto === true ||
                            p.pro_pedido_direto === 1 ||
                            p.pro_pedido_direto === "1"
                    );
                }

                if (this.filters.zeroQuantity) {
                    resp = resp.filter((p) => {
                        const quantidade = parseFloat(p.qtd || p.quantidade || 0);
                        return quantidade === 0;
                    });
                }
            }

            this.filteredProducts = resp;
            return resp;
        },
        searchProduct() {
            const time = new Date();
            this.searchTime = time;
            setTimeout(() => {
                if (this.searchTime == time) {
                    this.page = 1;
                    this.load_my_products();
                }
            }, 500);
        },
        cancelSearch() {
            if (this.cancelSource) {
                this.cancelSource.cancel("Start new search, stop active search");
            }
        },
        openHistoryModal(product) {
            const hasIdentifier = product.pro_ean || product.pro_codInterno;

            if (!hasIdentifier) {
                this.$swal.fire({
                    icon: "warning",
                    title: "Histórico não disponível",
                    text: "Este produto não possui histórico de compras e vendas disponível.",
                });
                return;
            }

            const visibleProducts = this.visible_products();
            this.currentProductIndex = visibleProducts.findIndex(
                (p) => p.pro_id === product.pro_id
            );
            this.current_product = product;
            this.store_number = this.store_number || this.current_store_number;

            this.quickViewSiblings = visibleProducts;
            this.quickViewSiblingIndex = this.currentProductIndex;
            this.quickViewReadonly = true;
            this.quickViewProduct = this.toQuickViewProduct(product);
            this.loadStores();
            this.quickViewVisible = true;
            this.loadQuickViewData();
        },
        handleProductChange(newIndex) {
            const visibleProducts = this.visible_products();
            if (visibleProducts[newIndex]) {
                this.currentProductIndex = newIndex;
                this.current_product = visibleProducts[newIndex];
                this.goToQuickViewProductAt(newIndex);
            }
        },
        toQuickViewProduct(product) {
            return {
                id: product.pro_id,
                name: product.pro_descricao,
                ean: product.pro_ean,
                internal_code: product.pro_codInterno,
                packing: product.pro_generico == 1 ? product.pro_unidade_compra : product.pro_embalagem,
                is_generic: product.pro_generico == 1,
                main_product_id: product.pro_principal || null,
                source: product,
            };
        },
        loadStores() {
            this.quickViewStores = this.store_number
                ? [{ id_loja: this.store_number, loja_descricao: this.nome_loja || `Loja ${this.store_number}` }]
                : [];
            this.selectedStoreId = this.store_number || null;
        },
        async goToQuickViewProductAt(index) {
            const nextProduct = this.quickViewSiblings && this.quickViewSiblings[index];

            if (!nextProduct) {
                return;
            }

            this.quickViewSiblingIndex = index;
            this.currentProductIndex = index;
            this.current_product = nextProduct;
            this.quickViewProduct = this.toQuickViewProduct(nextProduct);

            await this.loadQuickViewData();
        },
        editQuickViewPackaging() {
            const product = this.quickViewProduct && this.quickViewProduct.source;

            if (!product || !this.can('PRODUCT', 'DELETE') || product.pro_generico != 0) {
                return;
            }

            this.edit_wrap(product);
        },
        getActions(record) {
            return [
                {
                    label: "Editar produto",
                    icon: "edit",
                    iconClass: "action-info",
                    onClick: () => this.editProduct(record),
                },
                {
                    label: "Alterar embalagem",
                    icon: "inventory_2",
                    iconClass: "action-warning",
                    visible: this.can('PRODUCT', 'DELETE') && record.pro_generico == 0,
                    onClick: () => this.edit_wrap(record),
                },
                {
                    label: "Análise de giro",
                    icon: "query_stats",
                    iconClass: "action-primary",
                    onClick: () => this.openHistoryModal(record),
                },
                { divider: true },
                {
                    label: "Excluir",
                    icon: "delete",
                    iconClass: "action-danger",
                    onClick: () => this.remove(record),
                },
            ];
        },
        toggleLock() {
            this.isLocked = !this.isLocked;
        },
        removeSelectedOneByOne() {
            if (this.selectedProductsCount === 0) return;

            this.confirm_action({
                message: `Remover ${this.selectedProductsCount} produto(s) do ressuprimento?`,
                confirm_text: "Remover",
                icon: "warning",
                callback: () => this.removeSelectedProducts(),
            });
        },

        async removeSelectedProducts() {
            try {
                for (const product of this.selectedProducts) {
                    await this.service.remove_product_ressuply(this.quotationId, product.pro_id);
                    product.deleted = true;
                }

                this.snack(
                    `${this.selectedProductsCount} produto(s) removido(s) com sucesso!`,
                    "success"
                );
                await this.getProducts();
                this.$emit("loadRessuply");
            } catch (error) {
                console.error("Erro ao remover produtos:", error);
                this.handleRemoveError(error);
            }
        },

        remove(product) {
            this.confirm_action({
                message: `Remover "${product.pro_descricao}" do ressuprimento?`,
                confirm_text: "Remover",
                icon: "warning",
                callback: () => this.removeProduct(product),
            });
        },

        handleRemoveError(error, productName = null) {
            const apiMessage = error && error.response && error.response.data
                && (error.response.data.mensagem || error.response.data.message);

            this.snack(
                apiMessage || (productName
                    ? `Não foi possível remover "${productName}".`
                    : "Não foi possível remover os produtos selecionados."),
                "error"
            );
        },

        async removeProduct(product) {
            try {
                await this.service.remove_product_ressuply(this.quotationId, product.pro_id);
                product.deleted = true;
                await this.getProducts();
                this.$emit("loadRessuply");
                this.snack("Produto removido com sucesso!", "success");
            } catch (error) {
                console.error("Erro ao remover produto:", error);
                this.handleRemoveError(error, product.pro_descricao);
            }
        },

        editProduct(product) {
            this.$router.push({
                name: "Ressuprimento-Editar-Produto",
                params: { id: this.quotationId, productId: product.pro_id, product },
                query: { tab: "DATA" },
            });
        },

        handleError(error) {
            if (ErrorHandlerService && typeof ErrorHandlerService.handler === "function") {
                ErrorHandlerService.handler(error, this.$store);
            } else if (
                ErrorHandlerService &&
                typeof ErrorHandlerService.handle === "function"
            ) {
                ErrorHandlerService.handle(error, this.$store);
            } else {
                console.error("Erro:", error);
                this.$swal.fire({
                    icon: "error",
                    title: "Erro",
                    text: "Ocorreu um erro inesperado.",
                });
            }
        },

        handle_navigation($event, prod) {
            this.navigate($event, {
                ref: "amount",
                callback: {
                    function: this.update_one,
                    params: prod,
                },
            });
        },

        handle_my_products_navigation($event, product) {
            this.navigate($event, {
                ref: "new-amount",
                callback: {
                    function: this.add_product,
                    params: product,
                },
            });
        },
        hasSignificantChange(oldValue, newValue) {
            const oldVal = parseFloat(oldValue) || 0;
            const newVal = parseFloat(newValue) || 0;

            if (oldVal === 0 && newVal > 0) return true;

            if (Math.abs(newVal - oldVal) >= 5) return true;
            if (oldVal > 0 && Math.abs((newVal - oldVal) / oldVal) >= 0.2) return true;

            return false;
        },
        applySuggestion() {
            const visibleProducts = this.visible_products();
            let productsWithSuggestion = 0;

            visibleProducts.forEach((product) => {
                const qtdPadrao = parseFloat(product.qtd_padrao) || 0;
                const estoque = parseFloat(product.estoque) || 0;

                if (qtdPadrao > estoque) {
                    const sugestao = this.calculateSuggestion(product);

                    if (sugestao > 0) {
                        product.qtd = sugestao;
                        product.quantidade = sugestao;
                        product.changed = true;
                        productsWithSuggestion++;

                        if (!this.originalProductValues[product.pro_id]) {
                            this.originalProductValues[product.pro_id] = {};
                        }
                        this.originalProductValues[product.pro_id].qtd = sugestao;
                        product.originalQtd = sugestao;
                    }
                }
            });

            this.closeSuggestionAlert();

            if (productsWithSuggestion > 0) {
                this.service.updateQuotationProductsAmount(
                    this.quotationId,
                    visibleProducts
                        .filter((p) => p.changed)
                        .map((p) => ({
                            pro_id: p.pro_id,
                            quantidade: p.qtd
                        }))
                ).then(() => {
                    this.$swal.fire({
                        icon: "success",
                        title: "Sugestões Aplicadas!",
                        text: `Sugestões de quantidade foram aplicadas para ${productsWithSuggestion} produtos.`,
                        timer: 2000,
                        showConfirmButton: false,
                    });
                })
            } else {
                this.$swal.fire({
                    icon: "info",
                    title: "Nenhuma Sugestão",
                    text:
                        "Não há produtos com quantidade padrão maior que estoque para aplicar sugestões.",
                    timer: 2000,
                    showConfirmButton: false,
                });
            }
        },

        getSugestionPrice(item) {
            return this.calculateSuggestion(item);
        },

        calculateSuggestion(item) {
            if (!item) return 0;

            const qtdPadrao = parseFloat(item.qtd_padrao) || 0;
            const estoque = parseFloat(item.estoque) || 0;

            if (qtdPadrao <= estoque) return 0;

            const diferenca = qtdPadrao - estoque;

            if (diferenca <= 0) return 0;

            if (item.pro_generico == 1) {
                return diferenca;
            }

            if (item.pro_embalagem && item.pro_embalagem.includes(" ")) {
                const partes = item.pro_embalagem.split(" ");
                if (partes.length >= 2) {
                    const fatorEmbalagem = parseFloat(partes[1]) || 1;
                    return Math.round(diferenca / fatorEmbalagem);
                }
            }

            return Math.round(diferenca);
        },

        shouldShowSuggestionForProduct(product) {
            if (!product) return false;

            const qtdPadrao = parseFloat(product.qtd_padrao) || 0;
            const estoque = parseFloat(product.estoque) || 0;

            return qtdPadrao > estoque;
        },

        closeSuggestionAlert() {
            this.showSuggestionAlert = false;
            this.pendingSuggestionProduct = null;
            if (this.suggestionTimeout) {
                clearTimeout(this.suggestionTimeout);
                this.suggestionTimeout = null;
            }
        },

        async saveFieldAutomatically(product, field) {
            if (field !== "qtd") {
                return;
            }

            if (this.loading || !product || !product.pro_id) return;

            const currentValue = parseFloat(product[field]) || 0;
            const originalValue =
                parseFloat(
                    product[`original${field.charAt(0).toUpperCase() + field.slice(1)}`]
                ) || 0;

            if (currentValue === originalValue) {
                return;
            }

            if (this.saveTimeout) {
                clearTimeout(this.saveTimeout);
            }

            this.savingStatus = "saving";

            const productKey = product.pro_id;

            if (this.pendingAutoSaves.has(productKey)) {
                clearTimeout(this.pendingAutoSaves.get(productKey));
            }

            const timeoutId = setTimeout(async () => {
                try {
                    const quotationService = new QuotationService();

                    const updateData = {
                        pro_id: product.pro_id,
                        quantidade: field === "qtd" ? currentValue : product.qtd,
                        estoque: product.estoque?.toString() || "0",
                        qtd_padrao: product.qtd_padrao?.toString() || null,
                        obs: null,
                        custo: null,
                        venda: null,
                    };

                    await quotationService.updateQuotationProductAmount(
                        this.quotationId,
                        updateData
                    );

                    product[
                        `original${field.charAt(0).toUpperCase() + field.slice(1)}`
                    ] = currentValue;

                    this.pendingAutoSaves.delete(productKey);

                    this.showSaveFeedback(product, field);
                    this.savingStatus = "saved";

                    this.lastSaveTime = new Date();
                    this.saveTimeout = setTimeout(() => {
                        this.savingStatus = "idle";
                    }, 3000);
                } catch (error) {
                    console.error(`Erro ao salvar ${field} automaticamente:`, error);

                    product[field] = originalValue;

                    this.$swal.fire({
                        icon: "error",
                        title: "Erro ao salvar",
                        text: `Não foi possível salvar a alteração no ${field}.`,
                        timer: 2000,
                        showConfirmButton: false,
                    });

                    this.pendingAutoSaves.delete(productKey);
                    this.savingStatus = "idle";
                }
            }, 800);

            this.pendingAutoSaves.set(productKey, timeoutId);
        },

        showSaveFeedback(item, field) {
            if (field === "qtd") item.qtdSaved = true;
            if (field === "estoque") item.estoqueSaved = true;
            if (field === "qtdPadrao") item.qtdPadraoSaved = true;
        },

        handleBlur(item, field) {
            const currentValue =
                parseFloat(item[field === "qtdPadrao" ? "qtd_padrao" : field]) || 0;
            const originalValue = this.originalProductValues[item.pro_id]?.[field] || 0;

            if (currentValue !== originalValue) {
                this.savingStatus = "saving";
                this.saveIndividualProduct(item, field);
            }
        },
        handleInputChange(item, field, value) {
            const numericValue = Math.max(0, parseFloat(value) || 0);

            if (field === "qtdPadrao") {
                item.qtd_padrao = numericValue;
            } else {
                item[field] = numericValue;
            }

            if (field === "qtd" && numericValue > 0) {
                this.$set(item, "hasNewQuantity", true);
            }

            if (!this.originalProductValues[item.pro_id]) {
                this.saveOriginalValues(item);
            }

            if (this.shouldShowSuggestionForProduct(item)) {
                this.checkForSuggestion(item, field, numericValue);
            }
        },
        saveOriginalValues(product) {
            if (!product.pro_id) return;

            this.originalProductValues[product.pro_id] = {
                qtd: parseFloat(product.qtd) || 0,
                estoque: parseFloat(product.estoque) || 0,
                qtd_padrao: parseFloat(product.qtd_padrao) || 0,
            };

            product.originalQtd = parseFloat(product.qtd) || 0;
            product.originalEstoque = parseFloat(product.estoque) || 0;
            product.originalQtdPadrao = parseFloat(product.qtd_padrao) || 0;
        },
        checkForSuggestion(product, field, newValue) {
            if (this.suggestionTimeout) {
                clearTimeout(this.suggestionTimeout);
            }
            this.suggestionTimeout = setTimeout(() => {
                const originalValues = this.originalProductValues[product.pro_id];

                if (!originalValues) {
                    return;
                }

                const originalValue = originalValues[field];
                const hasChanged = this.hasSignificantChange(originalValue, newValue);

                const qtdPadrao = parseFloat(product.qtd_padrao) || 0;
                const estoque = parseFloat(product.estoque) || 0;
                const shouldShowSuggestion = qtdPadrao > estoque;

                if (hasChanged && !this.showSuggestionAlert && shouldShowSuggestion) {
                    this.pendingSuggestionProduct = {
                        ...product,
                        changedField: field,
                        originalValue: originalValue,
                        newValue: newValue,
                    };
                    this.showSuggestionAlert = true;
                }
            }, 800);
        },
        load_my_products() {
            this.loading = true;

            this.cancelSearch(() => {
                this.loading = true;
            });
            const params = {
                nomeproduto: this.product_name_filter,
                page: this.page,
                deleted: 0,
            };
            return this.service
                .getProdutosClientePorPagina(params, this.cancelSource?.token)
                .then((data) => {
                    this.my_products = data.data.produtos.data;
                    data.data.categorias.forEach((element) => {
                        if (element.cat_excluido != "1" && element.cat_status != "0")
                            this.my_categories.push({ value: element.cat_id, text: element.cat_descricao });
                    });

                    this.page = data.data.produtos.current_page;
                    setTimeout(() => {
                        this.total_items = data.data.produtos.total;
                    }, 200);
                    //this.totalPaginas = data.data.produtos.last_page;
                    this.products.forEach((v) => (v.expanded = false));
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        toggleSelectAll() {
            const visibleProducts = this.visible_products();
            const shouldSelectAll = !this.selectAll;

            visibleProducts.forEach((product) => {
                product.extract = shouldSelectAll;
            });

            this.selectAll = shouldSelectAll;
            this.isSelectAllIndeterminate = false;
        },
        initializeOriginalValues() {
            this.originalProductValues = {};
            this.visible_products().forEach((product) => {
                this.saveOriginalValues(product);
            });
        },
        toggleProductSelection() {
            const visibleProducts = this.visible_products();
            const selectedCount = visibleProducts.filter((p) => p.extract).length;
            const total = visibleProducts.length;

            if (selectedCount === 0) {
                this.selectAll = false;
                this.isSelectAllIndeterminate = false;
            } else if (selectedCount === total) {
                this.selectAll = true;
                this.isSelectAllIndeterminate = false;
            } else {
                this.selectAll = false;
                this.isSelectAllIndeterminate = true;
            }
        },
        updateSelectAllState() {
            const visibleProducts = this.visible_products();

            if (visibleProducts.length === 0) {
                this.selectAll = false;
                this.isSelectAllIndeterminate = false;
                return;
            }

            const selectedCount = visibleProducts.filter((product) => product.extract).length;
            const totalVisible = visibleProducts.length;

            this.selectAll = selectedCount === totalVisible;
            this.isSelectAllIndeterminate = selectedCount > 0 && selectedCount < totalVisible;
        },

        forceCheckboxUpdate() {
            this.$nextTick(() => {
                const checkbox = this.$refs.selectAllCheckbox;
                if (checkbox) {
                    checkbox.indeterminate = this.isSelectAllIndeterminate;
                }
            });
        },
        any_to_extract() {
            return this.selectedRowKeys.length > 0;
        },
        extract() {
            if (this.selectedProductsCount === 0) return;

            if (!this.any_to_extract()) {
                this.present_error("Selecione ao menos 1 item para proseguir!");
                return;
            }
            let items = this.selectedProducts.map(i => ({
                ...i,
                id: i.idProduto,
                quantity: i.quantidade,
            }));
            this.confirm_action({
                message: "Também excluir produtos selecionados da requisição atual?",
                cancel_text: "Não",
                confirm_tex: "Sim",
                deny_text: "Enviar sem exclusão",
                deny_callback: (result) => {
                    this.present_loader("Enviando requisição...");
                    this.svc_v3
                        .extract_resupply(this.quotationId, { items })
                        .then(this.getProducts)
                        .then((resp) => {
                            this.$emit("loadRessuply");
                            this.dismiss_loader();
                        });
                },
                callback: (result) => {
                    this.present_loader("Enviando requisição...");
                    this.svc_v3
                        .extract_resupply(this.quotationId, { items, remove_origin: true })
                        .then(this.getProducts)
                        .then((resp) => {
                            this.$emit("loadRessuply");
                            this.dismiss_loader();
                        });
                },
            });
        },
        closeDropdownOnClickOutside(e) {
            const dropdown = this.$el.querySelector(".items-filter");
            if (dropdown && !dropdown.contains(e.target)) {
                this.showItemsDropdown = false;
            }
        },
        extractEmbalagem(product) {
            if (!product) return "UN";

            if (product.pro_generico == 1) {
                return product.pro_unidade_compra || "UN";
            }

            if (product.pro_embalagem && product.pro_embalagem.includes(" ")) {
                return product.pro_embalagem.split(" ")[0];
            }

            return product.pro_embalagem || "UN";
        },
        getEmbalagensOptions(item) {
            if (!item) return this.defaultEmbalagens;

            if (item.pro_generico == 1) {
                return [{ value: item.pro_unidade_compra, text: item.pro_unidade_compra }];
            } else {
                const embalagemPadrao = item.pro_embalagem
                    ? item.pro_embalagem.includes(" ")
                        ? item.pro_embalagem.split(" ")[0]
                        : item.pro_embalagem
                    : "UN";

                const opcoes = [...this.defaultEmbalagens];

                if (embalagemPadrao && !opcoes.find((e) => e.value === embalagemPadrao)) {
                    opcoes.unshift({ value: embalagemPadrao, text: embalagemPadrao });
                }

                return opcoes;
            }
        },
        async onEmbalagemChange(item) {
            if (!item || !item.pro_id) return;

            const loading = this.$loading?.show();

            try {
                const payload = {
                    wrap: item.selectedEmbalagem,
                };

                const services = new ProductService();
                await services.update_wrap(item.pro_id, payload);

                item.pro_embalagem = payload.wrap;

                this.snack("Embalagem atualizada com sucesso!", "success");
            } catch (error) {
                console.error("Erro ao atualizar embalagem:", error);
                ErrorHandlerService.handle(error, this.$store);
                this.loadProductEmbalagem(item);
            } finally {
                loading?.hide();
            }
        },

        loadProductEmbalagem(item) {
            if (!item) return;

            if (item.pro_embalagem) {
                if (item.pro_embalagem.includes(" ")) {
                    item.selectedEmbalagem = item.pro_embalagem.split(" ")[0];
                } else {
                    item.selectedEmbalagem = item.pro_embalagem;
                }
            } else {
                item.selectedEmbalagem = "UN";
            }
        },
        hasEstoqueChanges(product) {
            if (!product || !product.pro_id) return false;

            const currentEstoque = parseFloat(product.estoque) || 0;
            const originalEstoque = parseFloat(product.originalEstoque) || 0;

            const estoqueChanged = currentEstoque !== originalEstoque;

            return estoqueChanged;
        },
        async saveIndividualProduct(product) {
            try {
                this.savingStatus = "saving";

                const quotationService = new QuotationService();

                const updateData = {
                    pro_id: product.pro_id,
                    quantidade: product.qtd,
                    estoque: product.estoque?.toString() || "0",
                    qtd_padrao: product.qtd_padrao?.toString() || "0",
                    obs: null,
                    custo: null,
                    venda: null,
                };

                await quotationService.updateQuotationProductAmount(this.quotationId, updateData);

                const currentEstoque = parseFloat(product.estoque) || 0;
                const originalEstoque = parseFloat(product.originalEstoque) || 0;
                const currentQtdPadrao = parseFloat(product.qtd_padrao) || 0;
                const originalQtdPadrao = parseFloat(product.originalQtdPadrao) || 0;

                product.originalQtd = parseFloat(product.qtd) || 0;
                product.originalEstoque = parseFloat(product.estoque) || 0;
                product.originalQtdPadrao = parseFloat(product.qtd_padrao) || 0;

                if (currentEstoque !== originalEstoque) {
                    product.estoqueSaved = true;
                }

                if (currentQtdPadrao !== originalQtdPadrao) {
                    product.qtdPadraoSaved = true;
                }

                this.snack("Produto salvo com sucesso.");

                this.savingStatus = "saved";
                this.lastSaveTime = new Date();

                if (this.saveTimeout) {
                    clearTimeout(this.saveTimeout);
                }
                this.saveTimeout = setTimeout(() => {
                    this.savingStatus = "idle";
                }, 3000);
            } catch (error) {
                console.error("Erro ao salvar produto individual:", error);
                this.snack("Erro ao salvar produto individual.", "error");
                this.savingStatus = "idle";
            }
        },
        handleKeydown(event, field, item, index) {
            if (event.key === "Enter") {
                event.preventDefault();
                const direction = event.key === "Enter" ? 1 : -1;
                this.navigateVertical(field, index, direction);
                return;
            }

            if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
                event.preventDefault();
                const direction = event.key === "ArrowRight" ? 1 : -1;
                this.navigateHorizontal(field, index, direction);
                return;
            }

            if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                event.preventDefault();
                const direction = event.key === "ArrowDown" ? 1 : -1;
                this.navigateVertical(field, index, direction);
                return;
            }
        },

        navigateHorizontal(currentField, currentIndex, direction) {
            const visibleProducts = this.visible_products();
            const fields = ["qtd", "estoque", "qtdPadrao"];

            let nextFieldIndex = fields.indexOf(currentField) + direction;
            let nextRowIndex = currentIndex;

            if (nextFieldIndex < 0) {
                nextFieldIndex = fields.length - 1;
                nextRowIndex--;
            } else if (nextFieldIndex >= fields.length) {
                nextFieldIndex = 0;
                nextRowIndex++;
            }

            if (nextRowIndex < 0) {
                nextRowIndex = 0;
            }

            if (nextRowIndex >= visibleProducts.length) {
                nextRowIndex = visibleProducts.length - 1;
            }

            this.focusOnInput(
                fields[nextFieldIndex],
                nextRowIndex
            );
        },

        navigateVertical(currentField, currentIndex, direction) {
            const visibleProducts = this.visible_products();
            const fields = ["qtd", "estoque", "qtdPadrao"];
            const currentFieldIndex = fields.indexOf(currentField);

            let nextRowIndex = currentIndex + direction;

            if (nextRowIndex < 0) {
                nextRowIndex = 0;
            } else if (nextRowIndex >= visibleProducts.length) {
                nextRowIndex = visibleProducts.length - 1;
            }

            if (nextRowIndex !== currentIndex && (this.quickViewVisible || this.quickViewWindowVisible)) {
                this.currentProductIndex = nextRowIndex;
                this.current_product = visibleProducts[nextRowIndex];
                this.handleProductChange(nextRowIndex);
            }

            this.focusOnInput(currentField, nextRowIndex);
        },

        focusOnInput(field, rowIndex) {
            this.$nextTick(() => {
                const input = this.$el.querySelector(
                    `[data-field="${field}"][data-row="${rowIndex}"]`
                );

                if (input) {
                    input.focus();
                    input.select();
                }
            });
        },
        focusAndOpenModal(product, index) {
            this.current_product = product;
            this.currentProductIndex = index;

            this.$nextTick(() => {
                const qtdInputs = this.$refs.qtdInputs;
                if (qtdInputs && qtdInputs[index]) {
                    qtdInputs[index].focus();
                    qtdInputs[index].select();
                }
            });
            this.openHistoryModal(product);
        },
    },
    watch: {
        quotationId: {
            handler: "loadQuotationData",
            immediate: true,
        },
        products: {
            handler() {
                this.$nextTick(() => this.forceCheckboxUpdate());
            },
            deep: true,
        },

        productFilter: {
            handler: function (newFilter, oldFilter) {
                if (oldFilter && !newFilter) {
                    this.products = [...this.originalProducts];
                }
                this.$nextTick(() => {
                    this.updateSelectAllState();
                    this.forceCheckboxUpdate();
                });
            },
        },

        categoryFilter: {
            handler: function () {
                this.$nextTick(() => {
                    this.updateSelectAllState();
                    this.forceCheckboxUpdate();
                });
            },
        },
        filters: {
            handler(newFilters) {
                const activeFilters = [];
                if (newFilters.directOrder) activeFilters.push("directOrder");
                if (newFilters.zeroQuantity) activeFilters.push("zeroQuantity");

                if (activeFilters.length === 0 && !this.selectedItemFilters.includes("all")) {
                    this.selectedItemFilters = ["all"];
                } else if (activeFilters.length > 0) {
                    this.selectedItemFilters = activeFilters;
                }
            },
            deep: true,
        },
        selectAll(newVal) {
            this.$nextTick(() => {
                this.forceCheckboxUpdate();
            });
        },

        isSelectAllIndeterminate(value) {
            this.$nextTick(() => {
                if (this.$refs.selectAllCheckbox) {
                    this.$refs.selectAllCheckbox.indeterminate = value;
                }
            });
        },
        selectedItemFilters: {
            handler(newFilters) {
                if (!Array.isArray(newFilters)) {
                    this.selectedItemFilters = [newFilters];
                }
            },
            deep: true,
            immediate: true,
        },
    },
    async mounted() {
        await this.load_my_products();
        document.addEventListener("click", this.closeDropdownOnClickOutside);

        this.$nextTick(() => {
            this.updateSelectAllState();
            this.forceCheckboxUpdate();

            this.initializeOriginalValues();
            this.visible_products().forEach((product) => {
                if (product.qtd_padrao && this.getSugestionPrice(product) != product.quantidade) {
                    this.pendingSuggestionProduct = {
                        ...product,
                    };
                    this.showSuggestionAlert = true;
                }
            });
        });
        this.$nextTick(this.updateTableHeight)
        window.addEventListener('resize', this.updateTableHeight)
    },
    beforeUnmount() {
        document.removeEventListener("click", this.closeDropdownOnClickOutside);
        if (this.suggestionTimeout) {
            clearTimeout(this.suggestionTimeout);
        }

        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
        }

        this.pendingAutoSaves.forEach((timeoutId) => {
            clearTimeout(timeoutId);
        });
        this.pendingAutoSaves.clear();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateTableHeight)
    },
};
</script>
<style lang="scss" scoped>
@import "@/sass/commons/_variables";
.request-title-display,
.request-title-input {
    width: 100%;
    max-width: 500px;
    height: 32px;
}

.request-title-display {
    height: 32px;
    padding: 4px 11px;

    display: flex;
    align-items: center;

    border: 1px solid transparent;
    border-radius: 4px;

    cursor: text;

    transition: all .2s;
}

// .request-title-display:hover {
//     border-color: #d9d9d9;
// }

.request-title-display span {
    font-size: 16px;
    color: rgba(0,0,0,.85);
}

.request-title-icon {
    opacity: 1;
    transition: opacity .2s;
}

.request-title-display:hover .request-title-icon {
    opacity: 1;
}


.request-title {
    display: inline-flex;
    align-items: center;
    gap: 8px;

    cursor: pointer;

    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
}

.request-title-icon {
    opacity: 0;
    transition: opacity .2s;
    font-size: 14px;
}

.request-title:hover .request-title-icon {
    opacity: 1;
}



.resupply-footer {
    position: fixed;
    left: 50%;
    bottom: 14px;
    transform: translateX(-50%);
    z-index: 999;

    width: calc(100% - 32px);
    max-width: 70vw;
    min-width: max-content;

    background: #22252a;
    border-radius: 10px;

    padding: 8px 16px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;

    box-shadow:
        0 8px 24px rgba(0, 0, 0, 0.24),
        0 2px 8px rgba(0, 0, 0, 0.16);
}

.resupply-footer-left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
    white-space: nowrap;

    color: #ffffff;
}

.resupply-footer-info {
    font-size: 0.74rem;
    color: rgba(255, 255, 255, 0.68);
}

.resupply-footer-count {
    font-size: 0.9rem;
    font-weight: 700;
    color: #ffffff;
}

.resupply-footer-total {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.84);
}

.resupply-footer-total strong {
    color: #ffffff;
    font-size: 0.9rem;
}

.resupply-footer-right {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
    white-space: nowrap;
}

.resupply-footer-right .ant-btn {
    height: 34px;
    padding: 0 16px;

    display: flex;
    align-items: center;
    gap: 6px;

    border: 0;
    border-radius: 8px;

    

    font-size: 0.8rem;
    font-weight: 600;

    transition: all 0.2s;
}

.create_button {
    background: #ff432d;
    color: #ffffff;
}

.resupply-footer-right .ant-btn:hover,
.resupply-footer-right .ant-btn:focus {
    background: #ff5a47;
    color: #ffffff;
}
.actions-col {
  display: flex;
  align-items: flex-end;
}

.actions-right {
  margin-left: auto;
  display: flex;
  gap: 8px;
  margin-left: auto;
  justify-content: flex-end;
}
.title-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 4px;
}
#app {
    background: #eeeeee !important;
}



.page {
    display: flex;
    width: 100%;
    height: 100vh;
    transition: all 0.3s ease;
    padding-right: 40px;
    font-family: $font-dm !important;
    box-shadow: none !important;
    overflow: hidden !important;

    &.with-drawer {
    }
}
.body {
    --quick-view-width: 500px;
}

.body.quick-view-open {
    padding-right: var(--quick-view-width);
    box-sizing: border-box;
}

.body.with-drawer {
    transition: all 0.3s ease;
    padding-right: 0;
    display: flex;
    height: 100vh;
    transition: all 0.3s ease;

}

.page-content {
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
}

.page-wrapper.with-drawer .page-content {
    width: calc(100% - 420px);
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease;
}

.slide-enter-from {
    opacity: 0;
    transform: scale(0.9);
}

.slide-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.slide-enter-to,
.slide-leave-from {
    opacity: 1;
    transform: scale(1);
}

.slide-enter-active .modal-wrapper,
.slide-leave-active .modal-wrapper {
    transition: transform 0.3s ease;
}

.page-route-select {
    display: flex;
    align-items: center;
}

.page-route-select-text {
    font-weight: 400;
    font-size: 1.36em;
    color: #ababab;
    margin-right: 20px;
    cursor: pointer;
}

.page-route-select-icon {
    color: var(--primary-color);
    margin-right: 20px;
}

.page-title {
    font-weight: 700;
    font-size: 2.72em;
    letter-spacing: 0.15px;
    color: #605f5f;
    display: flex;
    align-items: center;
    gap: 10px;

    .quotation {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 74px;
        height: 26px;
        border-radius: 16px;
        border: 1px solid #c7c9d9;
        background-color: #eeeeee;
        padding: 4px 8px;

        font-weight: 300;
        font-size: 0.8rem;
        color: #424242;
    }

    .save-status-indicator {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 20px;
        color: #424242;
        transition: all 0.3s ease;
    }

    .save-status-indicator .material-symbols-outlined {
        font-size: 22px;
        color: #424242;
    }

    .saving-spin {
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    .save-status-text {
        font-weight: 500;
        font-size: 1rem;
    }
}

.desktop {
    display: block;
}

.mobile {
    display: none;
}

.page-header,
.page-name-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}

.page-header-action {
    margin-top: 40px;
    display: flex;
    gap: 12px;
    color: #424242;
    cursor: pointer;
}

.info-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px 4px 6px;
    border-radius: 20px;
    background: #f0f1f7;
    border: 1px solid #c7c9d9;
    cursor: pointer;

    .info-tag-label {
        font-size: 0.8rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: #fff;
        background: #3a3a3c;
        border-radius: 12px;
        padding: 2px 8px;
        white-space: nowrap;
    }

    .info-tag-icon {
        font-size: 0.8rem;
        color: #605f5f;
    }

    .info-tag-value {
        font-weight: 500;
        font-size: 0.8rem;
        color: #3a3a3c;
        white-space: nowrap;
    }

    &.edit-name {
        &:hover {
            background: #e8e9f2;
        }
    }
}

.edit-request-name {
    display: flex;
    align-items: center;
}

.edit-request-name-input {
    border-radius: 4px;
    border: 1px solid #c7c9d9;
    font-weight: 400;
    font-size: 12px;
    color: #605f5f;
    width: 200px;
    height: 40px;
    padding: 2px;
    cursor: pointer;
}

.edit-request-name-icon {
    font-size: 1rem;
    margin-left: 1.5vw;
    cursor: pointer;
}

.page-buttons {
    display: flex;
    gap: 20px;
    text-wrap: nowrap;
    text-overflow: ellipsis;

    .btn-add {
        width: 200px;
        height: 47px;
        display: flex;
        border-radius: 8px;
        border: 1px solid #c7c9d9;
        padding: 12px;
        gap: 16px;

        font-weight: 600;
        font-size: 1rem;
        color: #424242;
    }

    .btn-save {
        width: 150px;
        display: flex;
        height: 47px;
        border-radius: 8px;
        padding: 12px;
        gap: 16px;
        border: none;
        background: #FF5722;

        font-weight: 600;
        font-size: 1rem;
    }
}

.resupply-alert {
    background: #e8eaf6;
    border: 1px solid #3f51b5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 20px;
    border-radius: 8px;

    .resupply-alert-text {
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 500;
        font-size: 1rem;
        color: #3f51b5;
    }

    .resupply-alert-actions {
        display: flex;
        gap: 10px;

        button {
            width: 150px;
            height: 47px;
            border-radius: 8px;
            padding: 12px;
            cursor: pointer;

            font-weight: 600;
            font-size: 0,6rem;
            color: #424242;
        }

        .ignore {
            background: none;
            border: none;
        }

        .apply {
            background: #eeeeee;
            border: 1px solid #c7c9d9;
        }
    }
}

.resupply-actions-container {
    min-height: 20px;
    display: flex;
    align-items: center;
    margin-top: 5px;
    position: relative;
    min-height: 30px;
}

.resupply-actions {
    display: flex;
    gap: 10px;
    width: 100%;
    background: transparent;

    button {
        border: none;
        background: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        font-size: 1rem;
        color: #424242;
    }
}

.resupply-actions button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.resupply-actions button:disabled:hover {
    transform: none;
}

.page-resupply-search {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 20px;
    gap: 10px;
    font-size: 1rem !important;
    font-weight: 400;
    position: relative;

    .resupply-search-buttons {
        display: flex;
        gap: 10px;

        .resupply-filter {
            width: 60%;
        }

        .resupply-filter-select {
            width: 200px;
            position: relative;
            font-size: 12px !important;
        }

        .items-filter {
            position: relative;
            width: 220px;
            margin-top: 12px;
        }

        .filter-select-display {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 42px;
            padding: 0 12px;
            background-color: #fff;
            border: 1px solid #ccc;
            border-radius: 6px;
            font-size: 1rem;
            color: #333;
            cursor: pointer;
            transition: border-color 0.2s ease;
        }

        .filter-select-display:hover {
            border-color: #999;
        }

        .filter-select-display .icon {
            font-size: 20px;
            color: #555;
        }

        .filter-selected-label {
            font-weight: 500;
            color: #333;
            margin-left: 4px;
        }

        .items-dropdown {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 8px 12px;
            display: flex;
            flex-direction: column;
            gap: 6px;
            z-index: 15;
            min-width: 100%;
            z-index: 1000;
            margin-top: 4px;
        }

        .items-dropdown label {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 1rem;
            cursor: pointer;
            color: #333;
        }

        .items-dropdown input[type="checkbox"] {
            accent-color: #ff6600;
            width: 16px;
            height: 16px;
        }
    }
}

.resupply-table-container {
    width: 100%;
    position: relative;
    background: #fff;

    &::-webkit-scrollbar {
        width: 3px;
        height: 4px;
    }

    &::-webkit-scrollbar-track {
        background: #f8f6f6;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #f8f6f6;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #f8f6f6;
    }

    .resupply-table thead {
        position: sticky;
        top: 0;
        z-index: 3;
        height: 60px;
        background: #fff;
    }

    .resupply-table tbody {
        z-index: -3;
    }

    .resupply-table {
        position: relative;
        z-index: 1;
        width: 100%;
        font-size: 1rem;
        color: #424242;
    }

    .resupply-table th {
        text-align: left;
        font-weight: 500;
        font-size: 1rem;
        color: #424242;
    }

    .resupply-table td {
        padding: 10px 3px;
        vertical-align: middle;
    }

    .resupply-table input[type="checkbox"] {
        appearance: none;
        -webkit-appearance: none;
        width: 22px;
        height: 22px;
        border: 2px solid #a5a5a5;
        border-radius: 4px;
        cursor: pointer;
        position: relative;
        background: white;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .resupply-table input[type="checkbox"]:checked {
        background-color: #FF5722;
        border-color: #FF5722;
    }

    .resupply-table input[type="checkbox"]:checked::after {
        content: "✔";
        position: absolute;
        color: white;
        font-size: 0.8rem;
        font-weight: bold;
    }

    .resupply-table input[type="checkbox"]:hover {
        border-color: #FF5722;
    }

    .input-num,
    .input-qtd {
        max-width: 52px;
        text-align: center;
        border-radius: 8px;
        padding: 8px 4px;
        font-weight: 400;
        background: none;
        border: 1px solid #c7c9d9;

        &:focus {
            border-color: orange !important;
            outline: none;
        }
    }

    .button-field {
        opacity: 0.5;
    }

    .input-wrapper {
        position: relative;
        display: inline-flex;
        align-items: center;

        i {
            color: green;
            position: absolute;
            right: -20px;
            font-size: 0.9rem;
            margin: 0;
        }
    }

    @keyframes fadeInOut {
        0% {
            opacity: 0;
        }

        10% {
            opacity: 1;
        }

        90% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .actions {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
    }

    .locked button,
    .actions button {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 18px;
        padding: 2px;
        color: #424242;
        transition: 0.2s;
    }

    .resupply-table th:last-child,
    .resupply-table td:last-child {
        width: 180px;
        text-align: left;
    }
}

.select-unit {
    border: none;
    font-size: 1rem;
    cursor: pointer;
}

.select-unidade:focus {
    outline: none;
}

.show-print {
    display: none;
}

@media only screen and (max-width: 768px) {
    .page {
        padding: 0 10px 5vh 10px;
        margin-bottom: 5vh;
        font-size: 1rem;
    }

    .page-content {
        width: 100%;
        overflow-y: scroll;
    }

    .page-route-select {
        font-size: 12px;
        margin-bottom: 10px;
    }

    .page-route-select-text {
        font-size: 1.1em;
        margin-right: 10px;
    }

    .page-route-select-icon {
        margin-right: 10px;
        font-size: 0.8rem;
    }

    .page-title {
        font-size: 1.8em;
        margin-top: 20px;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }

    .page-title span {
        width: auto;
        padding: 4px 8px;
        font-size: 12px;
    }

    .page-header-action span {
        font-size: 20px;
    }

    .info-tag {
        .info-tag-value {
            font-size: 13px;
        }
    }

    .page-name-actions {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin-top: 20px;
    }

    .resupply-search-buttons {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    }

    .page-resupply-search {
        flex-direction: column;
        gap: 10px;
        margin-top: 15px;
    }

    .resupply-filter {
        width: 100% !important;
    }

    .resupply-filter-select,
    .items-filter {
        width: 48% !important;
    }

    .desktop {
        display: none;
    }

    .mobile {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .resupply-cards-container {
        width: 100%;
        max-height: 90vh;
        overflow-y: auto;
        position: relative;
        margin-top: 40px;
    }

    .resupply-card {
        border-radius: 12px;
        padding: 14px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.06);
        display: flex;
        flex-direction: column;
        font-size: 1rem;
    }

    .card-header {
        display: flex;
        align-items: flex-start;
        padding: 20px 0;
        gap: 8px;
        background-color: none;
    }

    .card-header input[type="checkbox"] {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 2px solid #a5a5a5;
        appearance: none;
        cursor: pointer;
    }

    .card-header input[type="checkbox"]:checked {
        background-color: #FF5722;
        border-color: #FF5722;
        position: relative;
    }

    .card-header input[type="checkbox"]:checked::after {
        content: "✔";
        position: absolute;
        color: #fff;
        font-size: 1rem;
        left: 3px;
        top: 0;
    }

    .card-title {
        display: flex;
        flex-direction: column;
        font-weight: 600;
    }

    .card-title span {
        font-size: 12px;
        color: #777;
    }

    .card-body .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 0;
    }

    .card-body .row:last-child {
        border-bottom: none;
    }

    .card-body label {
        font-weight: 600;
        color: #3a3a3a;
    }

    .card-body input[type="number"] {
        width: 80px;
        text-align: center;
        border-radius: 8px;
        border: 1px solid #c7c9d9;
        background: #fafafa;
        padding: 5px;
        font-size: 13px;
    }

    .card-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        padding-top: 8px;
    }

    .card-actions button {
        background: none;
        border: none;
        color: #555;
        font-size: 18px;
        cursor: pointer;
    }

    .resupply-alert {
        display: flex;
        flex-direction: column;
        padding: 15px 20px;
        border-radius: 8px;
    }
}
</style>
